import { Mapper } from "planning-portal-library/src/lib/core/base";
import { MapProviderWebEntity } from "./map.web-entity";
import { MapProvider } from "planning-portal-library/src/lib/core/domain/models/map-provider.model";

export class MapProviderWebRepositoryMapper extends Mapper<MapProviderWebEntity, MapProvider> {
  mapFrom(param: MapProviderWebEntity): MapProvider {
    return {
        id: param.id,
        name: param.name,
        url: param.url,
        maxZoom: param.maxZoom,
        minZoom:param.minZoom,
        maxNativeZoom: param.maxNativeZoom,
        detectRetina: param.detectRetina,
        isSelected: param.isSelected
    };
  }

  mapTo(param: MapProvider): MapProviderWebEntity {
    return {
        id: param.id,
        name: param.name,
        url: param.url,
        maxZoom: param.maxZoom,
        minZoom:param.minZoom,
        maxNativeZoom: param.maxNativeZoom,
        detectRetina: param.detectRetina,
        isSelected: param.isSelected
    };
  }

}
